import React from 'react';
import ClassAssembly  from 'views/ClassAssembly1E';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;